const FineArtHero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/a0d9f8498c55deba9f0ed61350a56f2b.jpeg')`
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Fine Art
          <span className="block text-teal-400">Photography</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto leading-relaxed">
          Personal artistic exploration through the lens, where photography becomes 
          a medium for creative expression and visual storytelling
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="#gallery" 
            className="inline-block px-8 py-3 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-colors duration-300 whitespace-nowrap"
          >
            View Gallery
          </a>
          <a 
            href="#statement" 
            className="inline-block px-8 py-3 border-2 border-white text-white rounded-full font-medium hover:bg-white hover:text-gray-900 transition-colors duration-300 whitespace-nowrap"
          >
            Artist Statement
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};

export default FineArtHero;